import type { FindingJumpTarget } from "@/hooks/useReportQuery";
import type { NeuroReview } from "@/types/neuroReview";
import type { StudyMetadataResponse } from "@/utils/dicomMetadataLoader";

export function neuroFindingTargets(
  result: NeuroReview | undefined,
  metadata: StudyMetadataResponse | null | undefined,
): Record<string, FindingJumpTarget> {
  const targets: Record<string, FindingJumpTarget> = {};
  if (!result?.successful_inference || !metadata) return targets;

  // RC3 emits the input filename, which canonicalization can preserve while
  // changing the SOP UID. Resolve against actual image keys in viewer order.
  const byFilename = new Map<string, FindingJumpTarget | null>();
  for (const [seriesId, instances] of Object.entries(metadata.series)) {
    instances.forEach((instance, sliceIndex) => {
      const filename = instance.s3_key.split("/").at(-1);
      if (!filename) return;
      byFilename.set(
        filename,
        byFilename.has(filename)
          ? null
          : {
              seriesId,
              sliceIndex,
              frameOfReferenceUid:
                metadata.series_metadata[seriesId]?.frame_of_reference_uid ?? null,
            },
      );
    });
  }
  for (const [condition, prediction] of Object.entries(result.predictions ?? {})) {
    if (prediction.predicted_class !== true || !prediction.top_slice) continue;
    const target = byFilename.get(prediction.top_slice);
    if (target) targets[condition] = target;
  }
  return targets;
}
